import { Component, Input } from 'ng-metadata/core';

/**
 * @ngdoc directive
 * @name mwFabTriggerButton
 * @module mw.components.fab
 *
 * @param {boolean} [is-pulsing=false] - It activates the pulsing animation.
 * @param {string} [label='Actions'] - Tooltip text.
 *
 * @description
 * `<mw-fab-trigger-button>` is a component that lives inside a `<md-fab-speed-dial>` directive that creates
 * a hamburger icon that transforms into an x when opened.
 *
 * @usage
 * <hljs hljs-language="html">
 *   <mw-fab-trigger-button></mw-fab-trigger-button>
 * </hljs>
 *
 */
@Component({
    selector: 'mw-fab-trigger-button',
    template: `
        <mw-fab label="{{$ctrl.label}}" is-pulsing="$ctrl.isPulsing"></mw-fab>
    `
})
export class FabTriggerButtonComponent {
    @Input('<') isPulsing: boolean = false;
    @Input('@') label: string = 'Actions';

    constructor() {
        'ngInject';
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/fab/fab-trigger-button.component.ts